import React from 'react'

export default function (props) {
  const [copied, set_copied] = React.useState(false)

  const copy_input = React.useRef()

  React.useEffect(e => {
    copy_input.current.select()
    document.execCommand('copy')
    set_copied(true)
  }, [])

  return (
    <div className={'input-grid'} style={{ width: '100%' }}>
      <aside className={'input input-text input-box'} data-size={'full'}>
        <label>
          <div className="input-box__title">{props.label}</div>
        </label>
        <input
          type={'text'}
          value={props.value}
          onFocus={e => {
            e.target.select()
            document.execCommand('copy')
            set_copied(true)
          }}
          readOnly={true}
          ref={copy_input}
        />
        {copied ? <div style={{ marginTop: '5px' }}>
          {props.copyMessage}
        </div> : null}
      </aside>
    </div>
  )
}